import { ArticleHeading2, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './CianChatError.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var CianChatError = function CianChatError(props) {
  var onClose = props.onClose,
    open = props.open;
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: open,
    onClose: onClose,
    width: "100%",
    maxWidth: 448,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['container'],
      "data-testid": "ConsultantCianChatErrorPopup",
      children: /*#__PURE__*/_jsx("div", {
        className: styles['title'],
        children: /*#__PURE__*/_jsx(ArticleHeading2, {
          as: "h2",
          children: "\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u044D\u0442\u043E\u0442 \u0447\u0430\u0442 \u0432\u0430\u043C \u043F\u043E\u043A\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D"
        })
      })
    })
  });
};